export { Scrim } from './scrim';
export type { ScrimProps } from './scrim';
